<template>
  <div class="container">
    <v-card class="mb-2" tile>
      <v-card-title>
        <span class="title font-weight-light">Informes</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="7" md="4">
            <v-text-field
              v-model="codInforme"
              prepend-icon="mdi-account"
              label="Ingrese el código del informe"
              hint="El código consta de 10 dígitos y debe ser provisto por la institución"
              maxlength="80"
              :rules="requiredRules"
              dense
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click.stop="buscarInforme"
          :loading="loading"
          :disabled="checkLen || loading"
          >Buscar Informe</v-btn
        >
      </v-card-actions>

      <v-data-table
        v-if="listaInformes.length"
        :headers="headers"
        :items="this.listaInformes"
        class="elevation-1 row-pointer"
        locale="es-ar"
        @click:row="seleccionVer"
        item-key="idInforme"
        :items-per-page="10"
        ref="myTable"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
        }"
      >
        <template v-slot:item.varios="{ item }">
          <v-simple-checkbox v-model="item.varios" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="blue"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="seleccionVer(item)"
                >mdi-magnify</v-icon
              >
            </template>
            <span>Ver Archivo</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <VerInforme
        v-if="editedItem != null"
        :visible="showVerInforme"
        :informe="editedItem"
        @close="showVerInforme = false"
      ></VerInforme>
      <VerImagenes
        :visible="showVerImagenes"
        :images="listaImagenes"
        @close="showVerImagenes = false"
      ></VerImagenes>
    </v-card>
  </div>
</template>
<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
<script>
import axios from "../../axios-auth.js";
import VerInforme from "../HistClin/VerInforme.vue";
import VerImagenes from "../HistClin/VerImagenes.vue";

export default {
  data: (vm) => ({
    headers: [
      { text: "Fecha", value: "fechaInformeString" },
      { text: "Título", value: "titulo" },
      { text: "Descripción", value: "descripcion" },
      { text: "Tipo Archivo", value: "extension" },
      { text: "Profesional", value: "nomProfesional" },
      { text: "Acciones", value: "actions" },
    ],
    loading: false,
    showVerInforme: false,
    codInforme: "",
    editedItem: null,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    showVerImagenes: false,
    listaImagenes: [],
    listaInformes: [],
  }),

  methods: {
    seleccionVer(item) {
      if (item.varios == false) {
        this.verInforme(item);
      } else {
        this.verImagenes(item);
      }
    },
    verInforme(item) {
      this.editedItem = item;
      this.showVerInforme = true;
    },
    verImagenes(flag) {
      this.listaImagenes = flag.imagenesInformes;
      this.showVerImagenes = true;
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },

    async buscarInforme() {
      this.loading = true;
      const filtrosData = {
        idUsuarioPaciente: this.$store.state.idUsuarioPaciente,
        codInforme: this.codInforme,
      };

      try {
        const { data } = await axios.get("/PortalPaciente/GetInforme?", {
          params: {
            idUsuarioPaciente: filtrosData.idUsuarioPaciente,
            codInforme: filtrosData.codInforme,
          },
        });
        this.listaInformes = data;
      } catch (error) {
        this.listaImagenes = [];
        this.showAlert({
          icon: "error",
          title:
            "No existe un informe con ese código asociado a su número de documento.",
          vm: self,
          timer: 3500,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  components: {
    VerInforme,
    VerImagenes,
  },
  computed: {
    checkLen() {
      if (this.codInforme.length < 10) return true;
      else return false;
    },
  },
};
</script>
